import {Schema} from '../schema.js';
import {TypeReference} from '../types.js';
import { Model, PModel } from '../engine.js';
import {DeepModelWalker} from './ModelWalker.js';
import {PropertyValue} from './PropertyPathWalker.js';
import {ModelSystemProperties} from './ModelSystemProperties.js';

export class ModelAvailability {
  applyModel(schema: Schema, model: PModel, typeRef: TypeReference): [PModel, PropertyValue[]] {
    let availChanges: PropertyValue[] = [];
    let modelWalker: DeepModelWalker = new DeepModelWalker(schema, model, typeRef);
    let propertyValue: PropertyValue | undefined;
    while (propertyValue = modelWalker.next()) {
      if (propertyValue.property.opts.availability) {
        for (const constraint of propertyValue.property.opts.availability) {
          if (!constraint.evaluate(model)) {
            ModelSystemProperties.addToUnAvailability(propertyValue);
            propertyValue.parent!.value[propertyValue.property.name] = undefined;
          } else {
            let value = ModelSystemProperties.removeFromUnAvailability(propertyValue);
            if (value) {
              propertyValue.parent!.value[propertyValue.property.name] = value;
              availChanges.push(propertyValue);
            }
          }
        }
      }
    }
    return [model, availChanges]
  }

}
